import { render, staticRenderFns } from "./event-detail-swiper.vue?vue&type=template&id=5a9a2aee&scoped=true&"
import script from "./event-detail-swiper.vue?vue&type=script&lang=js&"
export * from "./event-detail-swiper.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-swiper.vue?vue&type=style&index=0&id=5a9a2aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a2aee",
  null
  
)

export default component.exports